import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { GRID_FILTERS_DISPLAY_LIMIT } from '../../tools/constants';
import { getIndividualFacet } from '../../tools/getIndividualFacet';
import CategoriesToaster from '../CategoriesToaster';
import DiscoverByFacet from '../DiscoverByFacet/DiscoverByFacet';
import DraggableScroll from '../DraggableScroll';
import RefineButton from '../Refine';
import style from './GridFilters.module.scss';

const GridFilters = ({
  categoryId,
  facet = [],
  facetData = [],
  filter = '',
  handleStoreFilter = () => { },
  onCheckBoxChange = () => { },
  onClearAllBtnClick = () => { },
  onSortChange = () => { },
  onFacetToasterChange = () => { },
  resultsCount = null,
  selectedSort = '',
  sortData = { sortOptions: [] },
  storeDetails = { storeName: '', storeId: '' },
}) => {
  const isFacetSelected = facet?.length > 0 || !!filter;
  const filterFacetData = useMemo(() => (
    facetData
      .filter((facetItem) => {
        const filters = getIndividualFacet(facetData, facetItem.id);
        return filters.facetId !== 'productCategories';
      })
      .slice(0, GRID_FILTERS_DISPLAY_LIMIT)
      .map((facetItem) => {
        const filters = getIndividualFacet(facetData, facetItem.id);
        return (
          <DiscoverByFacet
            key={filters.facetId}
            appliedFacets={facet}
            facetId={filters.facetId}
            facetName={filters.facetName}
            onFacetToasterChange={onFacetToasterChange}
            options={filters.filters}
            resultsCount={resultsCount}
            variant="pill"
          />
        );
      })
  ), [facet, facetData, onFacetToasterChange, resultsCount]);
  return (
    <div className={style.gridFilters}>
      <DraggableScroll className={style.gridFiltersContainer}>
        <CategoriesToaster
          categoryId={categoryId}
          productCount={isFacetSelected ? resultsCount : null}
        />
        <RefineButton
          facet={facet}
          facetData={facetData}
          filter={filter}
          gridFilters
          handleStoreFilter={handleStoreFilter}
          isCategoryPage
          isFacetSelected={isFacetSelected}
          onCheckBoxChange={onCheckBoxChange}
          onClearAllBtnClick={onClearAllBtnClick}
          onSortChange={onSortChange}
          resultsCount={resultsCount}
          selectedSort={selectedSort}
          sortData={sortData}
          storeDetails={storeDetails}
        />
        {filterFacetData}
      </DraggableScroll>
    </div>
  );
};

export default GridFilters;

GridFilters.propTypes = {
  categoryId: PropTypes.string,
  facet: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  facetData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  filter: PropTypes.string,
  handleStoreFilter: PropTypes.func,
  onCheckBoxChange: PropTypes.func,
  onClearAllBtnClick: PropTypes.func,
  onSortChange: PropTypes.func,
  onFacetToasterChange: PropTypes.func,
  resultsCount: PropTypes.number,
  selectedSort: PropTypes.string,
  sortData: PropTypes.shape({
    sortOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  storeDetails: PropTypes.shape({
    storeName: PropTypes.string,
    storeId: PropTypes.string,
  }),
};
